export default __webpack_public_path__ + "static/media/Ies_Panel1.5810e330.jpg";